import { Container, Grid } from "@material-ui/core";
import Amplify, { DataStore } from "aws-amplify";
import { withAuthenticator } from "aws-amplify-react";
import { graphql } from "gatsby";
import * as _ from "lodash";
import React, { Fragment } from "react";
import { IAtlasDatumRequest } from "src/atlas/AtlasModels";
import AtlasLayout from "../atlas/blades/AtlasLayout";
import awsconfig from "../api/aws-exports";
import PortalDataset from "../portal/PortalDataset";
import { DataPortalService } from "../api/DataPortalService";
import PortalProject from "../portal/PortalProject";
import PortalProjects from "../portal/PortalProjects";
import { Hub, Logger } from "aws-amplify";
import "@aws-amplify/ui/dist/style.css";

if (typeof window !== "undefined") {
  window.Object.freeze = function (obj) {
    return obj;
  };
}

Amplify.configure(awsconfig);

const listener = async (data) => {
  switch (data.payload.event) {
    case "signIn":
      console.log("user signed in");
      // switchRoles("us-west-2");
      break;
    case "signUp":
      console.log("user signed up");
      break;
    case "signOut":
      await DataStore.clear();
      console.log("user signed out");
      break;
    case "signIn_failure":
      console.log("user sign in failed");
      break;
    case "tokenRefresh":
      console.log("token refresh succeeded");
      break;
    case "tokenRefresh_failure":
      console.log("token refresh failed");
      break;
    case "configured":
      console.log("the Auth module is configured");
  }
};

Hub.listen("auth", listener);
DataPortalService.redirectHostedUI();

Hub.listen("datastore", (hubData) => {
  const { event, data } = hubData.payload;

  if (event === "networkStatus") {
    console.log(`User has a network connection: ${data.active}`);
  }
});

interface IProps {
  title: string;
  models: Array<IAtlasDatumRequest>;
  components: [
    {
      component: string;
      props?: Object;
      gene?: string;
      labels?: string;
      diffExp?: string;
      points?: string;
      table?: string;
      attributes?: string;
    }
  ];
}

export const PortalPageTemplate: React.FC<any> = ({ components, models }) => {
  // Sub-Components
  const elComponents: any = [];
  for (const [index, value] of components.entries()) {
    switch (value.component) {
      case "portal-dataset":
        elComponents.push(
          <PortalDataset props={JSON.parse(value.props)} key={index} />
        );
        break;
      case "portal-project":
        elComponents.push(
          <PortalProject props={JSON.parse(value.props)} key={index} />
        );
        break;
      case "portal-projects":
        elComponents.push(
          <PortalProjects props={JSON.parse(value.props)} key={index} />
        );
        break;
    }
  }
  return (
    <Fragment>
      <Container fixed style={{ paddingBottom: "60px" }}>
        <Grid container spacing={4}>
          {elComponents}
        </Grid>
      </Container>
    </Fragment>
  );
};

const PortalPage = (props: any) => {
  // Rework this to pull params from {} and also redirect if fail
  const path: Array<string> = (props.location.href || "url/path").split("/");
  const { frontmatter, html } = props.data.page;
  let models = [];
  frontmatter.components.forEach((c: any) => {
    if (c.props !== null) {
      c.props = c.props.replace(/{[0-9]+}/gi, (m: string) => {
        const i = parseInt(m.replace("{", "").replace("}", ""), 10);
        return path[path.length - (1 + i)].replace(/_/g, " ");
      });
    }
  });

  if (frontmatter.models !== null) {
    frontmatter.models.forEach((model: IAtlasDatumRequest) => {
      model.url = model.url.replace(/{[0-9]+}/gi, (m: string) => {
        const i = parseInt(m.replace("{", "").replace("}", ""), 10);
        return path[path.length - (1 + i)];
      });
    });
    models = frontmatter.models;
  }

  return (
    <AtlasLayout config={props.data.config.frontmatter}>
      <PortalPageTemplate
        title={frontmatter.title}
        components={frontmatter.components}
        models={models}
      />
    </AtlasLayout>
  );
};

// // redirect to cognito hosted ui login page
// DataPortalService.redirectHostedUI();

export default withAuthenticator(PortalPage);

export const pageQuery = graphql`
  query PortalPage($id: String, $cid: String) {
    config: markdownRemark(id: { eq: $cid }) {
      frontmatter {
        title
      }
    }
    page: markdownRemark(id: { eq: $id }) {
      frontmatter {
        title
        models {
          name
          type
          url
        }
        components {
          component
          props
        }
      }
    }
  }
`;
